import { ImportExport } from "@mui/icons-material";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export const COUNT_PER_PAGE = 8;

export default function OrderTable({
  data = [],
  columns = [],
  height = 450,
  className = "",
  defaultSortKeyIndex = -1,
  defaultASC = true,
  noHeader = false,
  pageNum = 1,
  pageCount = 1,
  sortKey = {},
  onSortChange: handleSortKey = () => {},
  ...props
}) {
  // const handleSort = (a, b) => {
  //   const aValue = String(
  //     sortKey?.column?.cell
  //       ? renderToString(sortKey?.column?.cell(a))
  //       : a?.[sortKey?.column?.selector] ?? ""
  //   ).toLowerCase();
  //   const bValue = String(
  //     sortKey?.column?.cell
  //       ? renderToString(sortKey?.column?.cell(b))
  //       : b?.[sortKey?.column?.selector] ?? ""
  //   ).toLowerCase();

  //   const formattedValue = {
  //     a: aValue,
  //     b: bValue,
  //   };
  //   if (sortKey?.column?.type === "date") {
  //     formattedValue.a = dmy2ymdhis(aValue);
  //     formattedValue.b = dmy2ymdhis(bValue);
  //   }
  //   if (isDMY(aValue)) {
  //     formattedValue.a = dmy2ymdhis(aValue);
  //   }
  //   if (isDMY(bValue)) {
  //     formattedValue.b = dmy2ymdhis(bValue);
  //   }
  //   if (isDMYHIS(aValue)) {
  //     formattedValue.a = dmyhis2ymdhis(aValue);
  //   }
  //   if (isDMYHIS(bValue)) {
  //     formattedValue.b = dmyhis2ymdhis(bValue);
  //   }

  //   if (
  //     sortKey?.column?.type === "number" ||
  //     !isNaN(Number(aValue)) ||
  //     !isNaN(Number(bValue))
  //   ) {
  //     formattedValue.a = toNumber(aValue);
  //     formattedValue.b = toNumber(bValue);
  //   }

  //   if (Boolean(sortKey?.asc)) {
  //     return formattedValue.a > formattedValue.b ? -1 : 1;
  //   } else {
  //     return formattedValue.a < formattedValue.b ? -1 : 1;
  //   }
  // };

  return (
    <TableContainer
      className={`${className} overflow-auto scroll-thumb`}
      style={{
        width: "100%",
        height: height,
      }}
    >
      <Table style={{ width: "100%", cursor: "pointer" }}>
        {!noHeader && (
          <TableHead className="bg-white bg-opacity-5">
            <TableRow>
              {columns.map((column, columnIndex) => (
                <TableCell key={columnIndex}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                    title={column.label}
                  >
                    <b>{column.label}</b>
                    {column?.sortable !== "no" &&
                      column?.selector !== "actions" &&
                      column?.selector && (
                        <IconButton
                          size="small"
                          onClick={() => {
                            handleSortKey(columnIndex, column);
                          }}
                        >
                          <ImportExport
                            color={
                              columnIndex === sortKey?.index
                                ? sortKey.asc
                                  ? "primary"
                                  : "error"
                                : "inherit"
                            }
                          />
                        </IconButton>
                      )}
                  </div>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {Boolean(data?.length) ? (
            (data ?? []).map((row, index, self) => {
              return (
                <TableRow key={index} hover>
                  {columns.map((column, columnIndex) => (
                    <TableCell
                      key={columnIndex}
                      className={column?.cellCSS ?? ""}
                      align={column?.align ?? "left"}
                    >
                      {/* <LazyLoad> */}
                      {column?.cell
                        ? column.cell(row, index, self)
                        : row?.[column?.selector ?? ""]}
                      {/* </LazyLoad> */}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={columns?.length ?? 1} align="center">
                <b>No Data</b>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
